export const dataHooks = {
    button: 'fill-preview-button',
};
//# sourceMappingURL=FillPreview.constants.js.map